import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { ChevronRight } from 'lucide-react';

export default function SeguimientoImpagosForm({ initialData, onSubmit }) {
  const [formData, setFormData] = useState({
    periodo: initialData?.periodo || new Date().toISOString().slice(0, 7),
    total_facturas_vencidas: initialData?.total_facturas_vencidas ?? '',
    observaciones: initialData?.observaciones || '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const validate = () => {
    const next = {};
    if (!formData.periodo) next.periodo = 'El periodo es obligatorio';
    if (
      formData.total_facturas_vencidas !== '' &&
      Number(formData.total_facturas_vencidas) < 0
    ) {
      next.total_facturas_vencidas = 'Debe ser un numero mayor o igual a 0';
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSubmit({
      ...formData,
      total_facturas_vencidas:
        formData.total_facturas_vencidas === ''
          ? null
          : Number(formData.total_facturas_vencidas),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <Label>Periodo *</Label>
        <Input
          type="month"
          value={formData.periodo}
          onChange={(e) => handleChange('periodo', e.target.value)}
          className={errors.periodo ? 'border-red-500' : ''}
          data-testid="input-periodo-impagos"
        />
        {errors.periodo && <p className="text-red-500 text-xs mt-1">{errors.periodo}</p>}
      </div>

      <div>
        <Label>Facturas vencidas (opcional)</Label>
        <Input
          type="number"
          min="0"
          value={formData.total_facturas_vencidas}
          onChange={(e) => handleChange('total_facturas_vencidas', e.target.value)}
          className={errors.total_facturas_vencidas ? 'border-red-500' : ''}
          data-testid="input-total-facturas-vencidas"
        />
        {errors.total_facturas_vencidas && (
          <p className="text-red-500 text-xs mt-1">{errors.total_facturas_vencidas}</p>
        )}
      </div>

      <div>
        <Label>Observaciones</Label>
        <Textarea
          value={formData.observaciones}
          onChange={(e) => handleChange('observaciones', e.target.value)}
          rows={3}
          placeholder="Contexto de impagos, clientes o incidencias"
        />
      </div>

      <Button type="submit" className="w-full" data-testid="btn-submit-form">
        Continuar <ChevronRight className="w-4 h-4 ml-2" />
      </Button>
    </form>
  );
}
